var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTableCarrotDown = function SvgTableCarrotDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.476 14.476l4.325-4.33A.671.671 0 0016.327 9H7.673a.671.671 0 00-.474 1.147l4.325 4.329c.262.262.69.262.952 0z",
    fill: "#33AA40"
  })));
};

export default SvgTableCarrotDown;